export default __webpack_public_path__ + "static/media/arequipa-canyon_&_shadows.8734a3d8.jpg";